module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./LatestCoursesView.js"));
	}, "LatestCoursesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LatestCoursesView!./src/pages/Learn/LatestCourses/LatestCoursesView.js
// module id = 1233
// module chunks = 431